import { type Observable } from 'rxjs';

import {
  type ConfirmDialogButton,
  type ConfirmDialogButtonAction,
  type MessageFormat,
} from '@blaze-shared/workflow-domain';

/**
 * Asks the user a yes/no-style question and waits for their answer.
 *
 * A confirm-dialog node suspends the workflow until the user picks a button, and the action bound
 * to that button decides whether execution continues. Rendering the dialog with the running app's
 * theme is the engine's business.
 */
export abstract class EngineConfirmDialogs {
  /**
   * Opens the confirmation dialog.
   * @returns the action of the button the user picked.
   */
  abstract openConfirmDialog(
    title: string,
    message: string,
    buttons: ConfirmDialogButton[],
    messageFormat?: MessageFormat,
  ): Observable<ConfirmDialogButtonAction>;
}
